// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.profile.ServerProfileStats
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

export class ServerProfileStatsBase {
  /** Do NOT invoke directly, instead use strongly typed createServerProfileStatsBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadp.ServerProfileStats";
  }
  initFromJson(json, deserializeContext) {
    this.initServerProfileStats(json.avgActive, json.avgValue, json.firstAccess != null ? new Date(json.firstAccess) : null, json.label != null ? json.label : null, json.lastAccess != null ? new Date(json.lastAccess) : null, json.lastValue, json.maxActive, json.maxValue, json.minValue, json.numActive, json.stdDevValue, json.totalValue, json.valueHits);
  }
  initServerProfileStats(avgActive, avgValue, firstAccess, label, lastAccess, lastValue, maxActive, maxValue, minValue, numActive, stdDevValue, totalValue, valueHits) {
    this._avgActive = avgActive;
    this._avgValue = avgValue;
    this._firstAccess = firstAccess;
    this._label = label;
    this._lastAccess = lastAccess;
    this._lastValue = lastValue;
    this._maxActive = maxActive;
    this._maxValue = maxValue;
    this._minValue = minValue;
    this._numActive = numActive;
    this._stdDevValue = stdDevValue;
    this._totalValue = totalValue;
    this._valueHits = valueHits;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["avgActive"] = this._avgActive;
    retVal["avgValue"] = this._avgValue;
    retVal["firstAccess"] = this._firstAccess;
    retVal["label"] = this._label;
    retVal["lastAccess"] = this._lastAccess;
    retVal["lastValue"] = this._lastValue;
    retVal["maxActive"] = this._maxActive;
    retVal["maxValue"] = this._maxValue;
    retVal["minValue"] = this._minValue;
    retVal["numActive"] = this._numActive;
    retVal["stdDevValue"] = this._stdDevValue;
    retVal["totalValue"] = this._totalValue;
    retVal["valueHits"] = this._valueHits;
    return retVal;
  }
  get avgActive() {
    return this._avgActive;
  }
  set avgActive(value) {
    this._avgActive = value;
  }
  get avgValue() {
    return this._avgValue;
  }
  set avgValue(value) {
    this._avgValue = value;
  }
  get firstAccess() {
    return this._firstAccess;
  }
  set firstAccess(value) {
    this._firstAccess = value;
  }
  get label() {
    return this._label;
  }
  set label(value) {
    this._label = value;
  }
  get lastAccess() {
    return this._lastAccess;
  }
  set lastAccess(value) {
    this._lastAccess = value;
  }
  get lastValue() {
    return this._lastValue;
  }
  set lastValue(value) {
    this._lastValue = value;
  }
  get maxActive() {
    return this._maxActive;
  }
  set maxActive(value) {
    this._maxActive = value;
  }
  get maxValue() {
    return this._maxValue;
  }
  set maxValue(value) {
    this._maxValue = value;
  }
  get minValue() {
    return this._minValue;
  }
  set minValue(value) {
    this._minValue = value;
  }
  get numActive() {
    return this._numActive;
  }
  set numActive(value) {
    this._numActive = value;
  }
  get stdDevValue() {
    return this._stdDevValue;
  }
  set stdDevValue(value) {
    this._stdDevValue = value;
  }
  get totalValue() {
    return this._totalValue;
  }
  set totalValue(value) {
    this._totalValue = value;
  }
  get valueHits() {
    return this._valueHits;
  }
  set valueHits(value) {
    this._valueHits = value;
  }
}
//# sourceMappingURL=ServerProfileStatsBase.js.map
